<div class="not-logged-in-logo-container" *ngIf="!isLoggedIn">
  <img class="header_logo" [src]="'assets/images/logo/resy_logo.png'" [alt]="'Resy logo'"/>
  <img class="ms-4" [src]="'assets/images/logo/resy_logo_txt.png'" [alt]="'Resy logo'"/>
</div>
<div class="custom-html-data-container">
  <div class="returned-content" [innerHTML]="termsAndConditionsText"></div>
</div>
